export const LOGIN_PAGE_HIDE_ERROR = 'LOGIN_PAGE_HIDE_ERROR'

export const handleHideSubmitError = () => ({ type: LOGIN_PAGE_HIDE_ERROR })
